import { HelmetDexteel } from "@dexteel/mesf-core";
import { CartridgesManager } from "./components/CartridgesManager";

export const CartridgesPage = () => {
	return (
		<>
			<HelmetDexteel title="Cartridges" />
			<CartridgesManager />
		</>
	);
};
